module.exports = __webpack_public_path__ + "img/control.5e956c79.svg";